import React, { useContext } from 'react'
import { Grid, Hidden, Typography, Icon, Box } from '@material-ui/core'
import { contractsDetailsStyles } from './contracts-details.styles'
import { LandingPageLink } from '../../../../ui'
import { CONTRACT_DETAILS_BLOCKS } from './contracts-details.constants'
import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux'
import { UnblurInformationDialog } from '../../../two-factor/components/two-factor-dialog.component'
import { ModalContext } from '../../../../ui/modal/contexts'
import { formatDateToShort } from '../../../../core/utils/dateUtils'

const SensitiveField = ({ value, isTwoFactorAuthenticated, onUnblur }) => {
  if (isTwoFactorAuthenticated) {
    return <span style={contractsDetailsStyles.itemValue}>{value}</span>
  }

  return (
    <Box
      style={{ cursor: 'pointer' }}
      display="flex"
      alignItems="center"
      flexWrap="nowrap"
      onClick={onUnblur}
    >
      <Typography variant={'body1'} style={{ fontWeight: 'bold', marginRight: '8px' }}>
        {value}
      </Typography>
      <Icon fontSize="inherit">visibility_off</Icon>
    </Box>
  )
}

const getNestedValue = (obj, path) => {
  return path.split('.').reduce((current, key) => current?.[key], obj)
}

const renderFieldValue = (field, blockData, isTwoFactorAuthenticated, onUnblur) => {
  let value

  switch (field.type) {
    case 'computed':
      value = field.getValue(blockData)
      break
    case 'nested':
    case 'nested_boolean':
      value = getNestedValue(blockData, field.key)
      break
    default:
      value = blockData[field.key]
  }

  if ((value === null || value === undefined || value === '') && field.fallback) {
    value = blockData[field.fallback] || field.fallback
  }

  switch (field.type) {
    case 'sensitive':
      return (
        <SensitiveField
          value={value}
          isTwoFactorAuthenticated={isTwoFactorAuthenticated}
          onUnblur={onUnblur}
        />
      )
    case 'lowercase':
      return (
        <span style={contractsDetailsStyles.itemValue}>{value ? value.toLowerCase() : 'N/A'}</span>
      )
    case 'boolean':
    case 'nested_boolean':
      const boolValue = typeof value === 'string' ? value.toLowerCase() === 'true' : Boolean(value)
      return <span style={contractsDetailsStyles.itemValue}>{boolValue ? 'Sí' : 'No'}</span>
    case 'date':
      const formattedDate = formatDateToShort(value)
      return <span style={contractsDetailsStyles.itemValue}>{formattedDate || 'N/A'}</span>
    default:
      return <span style={contractsDetailsStyles.itemValue}>{value || 'N/A'}</span>
  }
}

const ContractBlock = ({ block, data, isTwoFactorAuthenticated, onUnblur, formatMessage }) => {
  const blockData = block.dataPath ? getNestedValue(data, block.dataPath) : data
  const IconComponent = block.icon

  return (
    <Grid item {...block.gridProps} style={contractsDetailsStyles.items}>
      <div style={contractsDetailsStyles.sectionContainer}>
        {IconComponent && (
          <Hidden mdDown>
            <IconComponent style={block.iconStyle} />
          </Hidden>
        )}
        <div style={contractsDetailsStyles.itemContainer}>
          <Typography variant="h6" style={contractsDetailsStyles.sectionTitle}>
            {formatMessage({ id: block.titleKey })}
          </Typography>

          {block.fields.map((field, index) => (
            <div key={index} style={contractsDetailsStyles.item}>
              <span style={contractsDetailsStyles.itemLabel}>
                {formatMessage({ id: field.translationKey })}
              </span>
              {renderFieldValue(field, blockData, isTwoFactorAuthenticated, onUnblur)}
            </div>
          ))}
          {block.landingLink && (
            <LandingPageLink href={block.landingLink.url}>
              {formatMessage({ id: block.landingLink.translationKey })}
            </LandingPageLink>
          )}
        </div>
      </div>
    </Grid>
  )
}

export function ContractDetailsComponent({ data }) {
  const { formatMessage } = useIntl()
  const {
    actions: { open },
  } = useContext(ModalContext)
  const isTwoFactorAuthenticated = useSelector(
    (state) => state.global.authData.isTwoFactorAuthenticated
  )

  const handleOpenUnblurDialog = () =>
    open({
      Component: UnblurInformationDialog,
      props: {
        close: () => {},
      },
      type: 'responsive',
    })

  return (
    <Grid container spacing={0}>
      {CONTRACT_DETAILS_BLOCKS.map((block) => (
        <ContractBlock
          key={block.id}
          block={block}
          data={data}
          isTwoFactorAuthenticated={isTwoFactorAuthenticated}
          onUnblur={handleOpenUnblurDialog}
          formatMessage={formatMessage}
        />
      ))}

      {/*       <ContractBlock
        block={INSPECTION_BLOCK}
        data={combinedData}
        isTwoFactorAuthenticated={isTwoFactorAuthenticated}
        onUnblur={handleOpenUnblurDialog}
        formatMessage={formatMessage}
      /> */}
    </Grid>
  )
}
